import { isFunc, isPromise } from "@insightfulscience/shared-utils/fn";

const merge = propName => (props, value) => ({
	...props,
	[propName]: {
		value,
		toJSON: () => null,
	},
});

const extract = propName => props => {
	const value = props[propName]?.value;
	const propsCopy = { ...props };
	delete propsCopy[propName];

	return [value, propsCopy];
};

const getPropsAndMerge = mergeFn => (getProps, value, ...args) => {
	const props = isFunc(getProps) ? getProps(...args) : null;
	return isPromise(props)
		? props.then(resolved => mergeFn(resolved, value))
		: mergeFn(props, value);
};

const NotSerializableProp = propName => {
	const ownMerge = merge(propName);
	return {
		merge: ownMerge,
		extract: extract(propName),
		getPropsAndMerge: getPropsAndMerge(ownMerge),
	};
};

export default NotSerializableProp;
